var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNintendo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5664 0H23.0508V42H32.5664C37.7681 42 42 37.7681 42 32.5664V9.43359C42 4.23191 37.7681 0 32.5664 0ZM32.5254 27.2344C29.7889 27.2344 27.5625 25.008 27.5625 22.2715C27.5625 19.535 29.7889 17.3086 32.5254 17.3086C35.2619 17.3086 37.4883 19.535 37.4883 22.2715C37.4883 25.008 35.2619 27.2344 32.5254 27.2344Z",
    fill: "#606161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5898 42H9.43359C4.23191 42 0 37.7681 0 32.5664V9.43359C0 4.23191 4.23191 0 9.43359 0H20.5898V42ZM9.43359 2.46094C5.58887 2.46094 2.46094 5.58887 2.46094 9.43359V32.5664C2.46094 36.4111 5.58887 39.5391 9.43359 39.5391H18.1289V2.46094H9.43359Z",
    fill: "#636364"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2949 17.3086C7.55844 17.3086 5.33203 15.0822 5.33203 12.3457C5.33203 9.60922 7.55844 7.38281 10.2949 7.38281C13.0314 7.38281 15.2578 9.60922 15.2578 12.3457C15.2578 15.0822 13.0314 17.3086 10.2949 17.3086Z",
    fill: "#636364"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNintendo);
export default __webpack_public_path__ + "static/media/nintendo.f579be0450cff9bf18cd4b3371f79436.svg";
export { ForwardRef as ReactComponent };